import React, { Component } from 'react'
import SearchItemTop from '../SearchItemTop'
import ConfirmBtn from '../ConfirmBtn'
import commonMethod from "../../lib/commonMethod";


class PaperSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keywordList: null,
            selectedKeyword: [],
            isOpen: props.data.condition === "editing",
            loading: true,
        };
    }

    componentDidMount() {

        if (this.props.data.keyword && this.props.data.keyword.length > 0) {

            this.setState({
                keywordList: this.props.data.keywordAll,
                selectedKeyword: this.props.data.keyword,
                loading: false,
            })

            this.props.editItem(this.props.data, this.props.data.keyword, this.props.data.keywordAll);
        } else {
            if (this.props.data.condition === "editing") this.getResult(this.props.data.code);
        }


    }

    componentWillUpdate(props, state) {
        if (!this.state.isOpen && (props.data.condition === "editing" || props.data.condition === "editable")) {
            this.setState({ isOpen: true });
            // this.getResult(this.props.data.code)
        } else if (this.state.isOpen && props.data.condition === "complete") {
            this.setState({ isOpen: false });
        } else if (this.state.isOpen && props.data.condition === "waiting") {
            this.setState({ selectedKeyword: props.data.keyword, isOpen: false, loading: true })
        } else if (this.state.selectedKeyword !== props.data.keyword) {
            this.setState({ selectedKeyword: props.data.keyword })
        }
    }


    getResult(code) {

        let keywordList = null;

        let searchList = this.props.searchList;
        let data = commonMethod.makeParameter(this.props.userId, this.props.accessToken, code, searchList);
        commonMethod.requestStepSearch('https://d7ecgx9wn9.execute-api.us-west-1.amazonaws.com/step_search', data, res => {
            let keywordList = [];
            if (res.data && typeof res.data == "object" && !res.data.errorMessage) {
                res.data.map((item, key) => {
                    if (item !== "") {
                        if (item.common_name) {
                            keywordList.push({
                                code: this.props.data.code,
                                title: item.common_name,
                                keyword: item.scientific_name,
                            });
                        } else {
                            if (code === 4 || code === 8) {
                                if (item.keywords) {
                                    let keywordLength = item.keywords.length;
                                    for (let i = 0; i < keywordLength; i++) {
                                        if (item.keywords[i] === "" || item.keywords[i] === "unknown") {
                                            item.keywords.splice(i, 1);
                                        }
                                    }
                                }
                                keywordList.push({
                                    id: key,
                                    code: this.props.data.code,
                                    title: item.title,
                                    keyword: item.keywords,
                                    keywordDetail: {
                                        Title: item.title,
                                        Cited_by: item.cited_by,
                                        Journal_title: item.journal_title,
                                        Lang: item.lang,
                                        Link_url: item.link_url,
                                        Link_url_check: item.link_url_check,
                                        Summary: item.summary,
                                        Year: item.year,
                                        Authors: item.authors,
                                        close: false,
                                        type: this.props.type
                                    }
                                });
                            } else if (code === 5) {
                                keywordList.push({
                                    id: key,
                                    code: this.props.data.code,
                                    title: item.sname,
                                    keyword: item.cname,
                                });
                            }
                        }
                    }
                });

                this.setState({
                    keywordList: keywordList,
                });

                this.props.editItem(this.props.data, [], keywordList);
            }

            this.setState({ loading: false });
        });


        this.setState({ keywordList: keywordList })
        this.props.editItem(this.props.data, [], keywordList);
    }

    toggleKeyword(e, data) {
        let type = this.props.type;
        if (e.target.tagName == "A") return false;

        let condition = this.props.data.condition

        if (condition === "editing" || condition === "editable") {
            let selectedKeyword = this.state.selectedKeyword;
            let idx = selectedKeyword.findIndex(keyword => keyword === data);
            if (idx > -1) {
                selectedKeyword.splice(idx, 1);
            } else {
                selectedKeyword.push(data);
            }

            this.setState({ selectedKeyword: selectedKeyword })

            this.props.editItem(this.props.data, selectedKeyword, this.state.keywordList, type);
        }

    }

    confirm() {

        if (this.state.selectedKeyword.length !== 0) {
            // console.log(this.state.keywordList);
            this.props.addSearchKeyword(this.state.selectedKeyword);
        }
    }


    render() {

        let keywordList = this.state.keywordList;
        let data = this.props.data;
        return (
            <div id={data.id} className={data.condition === "waiting" ?
                "search-item-wrap paper-keyword movable" : "search-item-wrap paper-keyword"}>
                <SearchItemTop addLibrary={(type, id, code) => this.props.addLibrary(type, id, code)}
                    data={this.props.data} isOpen={this.state.isOpen} keywordList={this.state.selectedKeyword}
                    setIsOpen={(isOpen) => this.setState({ isOpen: isOpen })}
                    deleteItem={() => this.props.deleteItem()}
                    libraryList={this.props.libraryList} />

                {(this.state.isOpen || data.condition === "editing") &&
                    <React.Fragment>
                        {!this.state.loading && (keywordList && keywordList.length !== 0) && <p className="total-count">Total : {keywordList.length}</p>}
                        {!this.state.loading ?
                            (keywordList && keywordList.length !== 0) ?
                                <ul className="keyword-list">
                                    {keywordList.map((v, k) => {
                                        v.type = this.props.type;

                                        if (v.sname && v.sname.indexOf(" ") > -1) {
                                            v.sname.replace(' ', '-');
                                        }

                                        let selectedKeyword = this.state.selectedKeyword;
                                        // console.log(selectedKeyword);
                                        let isExist = selectedKeyword.findIndex(keyword => keyword.id === v.id) !== -1 ? true : false;

                                        let isArray = Array.isArray(v.keyword);

                                        return <li key={k} className={isExist ? "active" : ""} onClick={(e) => this.toggleKeyword(e, v)}>
                                            <p className="title-wrap">
                                                <span>
                                                    {v.title}
                                                    {!isArray && <i className="bio-text">{v.keyword}</i>}
                                                </span>

                                            </p>
                                            {keywordList.length > 0 && v.keywordDetail && <button className="detail-keyword"
                                                onClick={(e) => this.props.keywordDetail(e, v.keywordDetail)}>i</button>}

                                            {this.props.data.code === 5 && <a className="detail-keyword white" href={"https://lib.mimic.us/taxon/search?=" + v.sname} target="_blank">i</a>}

                                            {(isArray && v.keyword && v.keyword.length !== 0) &&
                                                <ul>
                                                    {v.keyword.map((w, i) => {
                                                        if (w !== "" && w !== "Unknown") {
                                                            return (
                                                                <li key={i}>
                                                                    {w}
                                                                </li>
                                                            )
                                                        }
                                                    })}
                                                </ul>
                                            }
                                            <ul></ul>
                                        </li>
                                    })}
                                </ul> : <p className="no_result_text">No search results found.</p>
                            : <p className="no_result_text">{this.props.type == 'Articles' ? 'It may take 10 seconds' : 'loading..'}</p>}

                        {(data.condition !== "complete" && data.condition !== "editable") &&
                            <ConfirmBtn isConfirm={this.props.beforeItem ? this.props.beforeItem.keyword.length !== 0 && this.state.selectedKeyword.length !== 0 : this.state.selectedKeyword.length !== 0}
                                onClick={() => this.confirm()} />
                        }

                    </React.Fragment>
                }
            </div>
        )
    }
}


export default PaperSearch;

